import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppShell } from '@/components/layout/AppShell';
import { PageContainer } from '@/components/layout/PageContainer';
import { TopBar } from '@/components/layout/TopBar';
import { NewsCard } from '@/components/domain/NewsCard';
import { useNews } from '@/api/queries/news';
import { Spinner } from '@/components/ui/Spinner';
import { paths } from '@/routes/paths';

export function NewsFeedPage(): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const news = useNews({ limit: 30 });
  return (
    <AppShell>
      <PageContainer>
        <TopBar back title={t('news.title')} />
        {news.isLoading && <Spinner />}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {news.data?.items?.map((n) => (
            <NewsCard key={n.id} item={n} onClick={() => navigate(paths.newsArticle(n.id))} />
          ))}
          {!news.isLoading && !news.data?.items?.length && (
            <div style={{ color: 'var(--color-text-on-dark-muted)' }}>{t('news.empty')}</div>
          )}
        </div>
      </PageContainer>
    </AppShell>
  );
}
